<template>
  <div class="ca-login-container">
    <div class="head"></div>
    <div class="form">
      <div class="title">你好，欢迎登录星火</div>
      <div class="mobile-input-container" style="margin-top: 45px;">
        <div style="flex: 1; height: 54px; position: relative;">
          <input class="mobile-input" placeholder="请输入手机号" maxlength="11" v-model="formData.phoneNo">
        </div>
      </div>
      <div class="mobile-input-container" style="margin-top: 20px;">
        <div style="flex: 1; height: 54px; position: relative;">
          <input class="mobile-input" placeholder="请输入验证码" maxlength="6" v-model="formData.bookingCode">
          <span class="code-title" @click="onSendCode" v-if="!counting">获取验证码</span>
          <span class="code-title" v-else>{{countDown}}s</span>
        </div>
      </div>
      <div class="mobile-protocol" style="margin-top: 20px;">
        <van-checkbox v-model="formData.checked"></van-checkbox>
        <span>我已阅读并同意《<a @click="onGoToProtocol('1')">星火贷款服务授权协议</a>》、《<a @click="onGoToProtocol('2')">授权协议</a>》</span>
      </div>
      <div class="mobile-button">
        <van-button type="info" block round @click="onSubmit">登录</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import * as RegExp from '@/constants/regExp'
import { sendCode, login } from '@/services/OrderService'

export default {
  data() {
    return {
      counting: false,
      countDown: 60,
      formData: {
        phoneNo: '',
        bookingCode: '',
        checked: false
      }
    }
  },
  methods: {
    async onSendCode() {
      if (!this.counting) {
        if (!RegExp.PHONE_REG.test(this.formData.phoneNo)) {
          this.$toast('请填写正确的手机号')
          return
        }
        if (!this.formData.checked) {
          this.$toast('请先阅读授权协议')
          return false
        }
        const response = await sendCode({
          phoneNo: this.formData.phoneNo,
        })
        if (response.code === 1000) {
          this.$toast({
            message: '发送成功，请查收',
            duration: 3000
          })
        }
        this.counting = true
        clearInterval(this.sendTimer)
        this.sendTimer = setInterval(() => {
          this.countDown = this.countDown - 1
          if (this.countDown === 0) {
            clearInterval(this.sendTimer)
            this.counting = false
            this.countDown = 60
          }
        }, 1000)
      }
    },
    onGoToProtocol(name) {
      this.$router.push(`/ca/protocol${name}`)
    },
    async onSubmit() {
      if (!this.validateFormValue()) {
        return
      }
      const response = await login({
        phoneNo: this.formData.phoneNo,
        vcode: this.formData.bookingCode
      })
      if (response.code === 1000) {
        localStorage.setItem('has_login', 'has_login')
        this.$toast('登录成功')
        this.$router.push('/ca/home')
      }
      
    },
    validateFormValue(showMessage = true) {
      const { phoneNo, bookingCode, checked } = this.formData
      if (!RegExp.PHONE_REG.test(phoneNo)) {
        showMessage && this.$toast('请填写正确的手机号')
        return false
      }
      if (!RegExp.CODE_REG.test(bookingCode)) {
        showMessage && this.$toast('请填写正确的验证码')
        return false
      }
      if (!checked) {
        showMessage && this.$toast('请先阅读授权协议')
        return false
      }
      return true
    }
  }
}
</script>
<style lang="less">
.ca-login-container {
  .head {
    width: 100%;
    height: 198px;
    background: linear-gradient(0deg, #fff, #4e77eb 83%);
  }
  .form {
    margin: 0 auto;
    margin-top: -110px;
    width: 356px;
    border-radius: 22px;
    background-color: #fff;
    padding-bottom: 35px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin-top: 40px;
      font-size: 25px;
      font-weight: 600;
      color: #000;
    }
    .mobile-input-container {
      width: 314px;
      height: 54px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      background: #f0f0f0;
      border-radius: 27px;
      font-size: 15px;
      font-weight: 600;
      color: #333;
      text-align: center;
      .mobile-input {
        position: relative;
        display: block;
        height: 100%;
        background: none;
        opacity: 1;
        line-height: 54px;
        border: none;
        width: 100%;
        &::-webkit-input-placeholder {
          color: #aaa;
        }
      }
      .code-title {
        font-weight: 700;
        color: #1db8fa;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
    .mobile-protocol {
      margin-top: 20px;
      font-size: 14px;
      display: flex;
      width: 314px;
      a {
        color: #1db8fa;
      }
      .van-checkbox__icon {
        width: 35px;
      }
    }
    .mobile-button {
      width: 314px;
      margin-top: 20px;
    }
  }
}
</style>